import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface PunishmentItem {
  departmentName: string
  reason: string
  content: string
  decisionDate: string
  punishNumber: string
  source: string
}

interface Props {
  data: any
  title: string
  sectionIndex?: string
}

const normalizeItems = (items: PunishmentItem[] = []) =>
  items.map((item) => ({
    department: item.departmentName || '—',
    reason: item.reason || '—',
    content: item.content || '—',
    decisionDate: item.decisionDate ? dayjs(item.decisionDate).format('YYYY-MM-DD') : '—',
    number: item.punishNumber || '—',
    source: item.source || '—',
  }))

export default function TianyanchaPunishmentInfo({ data, title, sectionIndex }: Props) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_punishmentInfo ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const punishments = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          行政处罚
        </Text>
        <Stack gap="sm" className="mt-3">
          {punishments.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无行政处罚记录
            </Text>
          ) : (
            punishments.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.number}-${index}`}
                number={index + 1}
                recordType="处罚"
                fields={[
                  { label: '处罚文号', value: item.number },
                  { label: '处罚日期', value: item.decisionDate },
                  { label: '处罚机关', value: item.department },
                  { label: '处罚原因', value: item.reason },
                  { label: '处罚内容', value: item.content, span: 2 },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
